import React, { Fragment } from "react";
import cx from "classnames";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";

export default ({
    items,
    label,
    selected,
    setSelected,
    errors = [],
    ...props
}) => {
    return (
        <>
            <Listbox value={selected} onChange={setSelected} multiple={false}>
                {({ open }) => (
                    <>
                        <Listbox.Label
                            className={
                                "block text-sm font-medium text-gray-700"
                            }
                        >
                            {label}
                        </Listbox.Label>
                        <div className="relative mt-1">
                            <Listbox.Button
                                className={
                                    "relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                }
                            >
                                <span className="block truncate">
                                    {selected.name} &nbsp;
                                </span>
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                    <SelectorIcon
                                        className={"h-5 w-5 text-gray-400"}
                                        aira-hidden={"true"}
                                    />
                                </span>
                            </Listbox.Button>
                            <Transition
                                show={open}
                                as={Fragment}
                                leave={"transition ease-in duration-100"}
                                leaveFrom={"opacity-100"}
                                leaveTo={"opacity-0"}
                            >
                                <Listbox.Options
                                    className={
                                        "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                                    }
                                >
                                    {items.map((item) => (
                                        <Listbox.Option
                                            key={item.id}
                                            value={item}
                                            className={({ active }) =>
                                                cx(
                                                    "relative cursor-default select-none py-2 pl-8 pr-4",
                                                    {
                                                        "bg-indigo-600 text-white":
                                                            active,
                                                        "text-gray-900":
                                                            !active,
                                                    }
                                                )
                                            }
                                        >
                                            {({ active, selected }) => (
                                                <>
                                                    <span
                                                        className={cx(
                                                            "block truncate",
                                                            {
                                                                "font-semibold":
                                                                    selected,
                                                                "font-normal":
                                                                    !selected,
                                                            }
                                                        )}
                                                    >
                                                        {item.name}
                                                    </span>
                                                    {selected ? (
                                                        <span
                                                            className={cx(
                                                                "absolute inset-y-0 left-0 flex items-center pl-1.5",
                                                                {
                                                                    "text-white":
                                                                        active,
                                                                    "text-indigo-600":
                                                                        !active,
                                                                }
                                                            )}
                                                        >
                                                            <CheckIcon
                                                                className={
                                                                    "h-5 w-5"
                                                                }
                                                                aria-hidden={
                                                                    true
                                                                }
                                                            />
                                                        </span>
                                                    ) : null}
                                                </>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </Listbox.Options>
                            </Transition>
                        </div>
                    </>
                )}
            </Listbox>
            {errors && <p className="mt-2 text-sm text-red-600">{errors}</p>}
        </>
    );
};
